var _g, _g2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSearchGe = function SvgSearchGe(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_54167",
    "data-name": "Group 54167",
    width: 21,
    height: 21,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54150",
    "data-name": "Group 54150",
    transform: "translate(1.545 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5329",
    "data-name": "Rectangle 5329",
    width: 2.091,
    height: 2.091,
    transform: "translate(0 1.545)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5330",
    "data-name": "Rectangle 5330",
    width: 2.091,
    height: 2.091,
    transform: "translate(1.545)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5331",
    "data-name": "Rectangle 5331",
    width: 2.091,
    height: 2.091,
    transform: "translate(7.727 3.091)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5332",
    "data-name": "Rectangle 5332",
    width: 2.091,
    height: 2.091,
    transform: "translate(7.727 6.182)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5333",
    "data-name": "Rectangle 5333",
    width: 2.091,
    height: 2.091,
    transform: "translate(6.182 7.727)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5375",
    "data-name": "Rectangle 5375",
    width: 2.091,
    height: 2.091,
    transform: "translate(9.273 10.818)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5376",
    "data-name": "Rectangle 5376",
    width: 2.091,
    height: 2.091,
    transform: "translate(10.818 12.363)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5377",
    "data-name": "Rectangle 5377",
    width: 2.091,
    height: 2.091,
    transform: "translate(12.363 13.909)",
    fill: "#15081f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54151",
    "data-name": "Group 54151",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5329-2",
    "data-name": "Rectangle 5329",
    width: 2.091,
    height: 2.091,
    transform: "translate(7.727 1.545)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5330-2",
    "data-name": "Rectangle 5330",
    width: 2.091,
    height: 2.091,
    transform: "translate(6.182)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5331-2",
    "data-name": "Rectangle 5331",
    width: 2.091,
    height: 2.091,
    transform: "translate(0 3.091)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5332-2",
    "data-name": "Rectangle 5332",
    width: 2.091,
    height: 2.091,
    transform: "translate(0 6.182)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5333-2",
    "data-name": "Rectangle 5333",
    width: 2.091,
    height: 2.091,
    transform: "translate(1.545 7.727)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5373",
    "data-name": "Rectangle 5373",
    width: 2.091,
    height: 2.091,
    transform: "translate(3.091 9.273)",
    fill: "#15081f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5374",
    "data-name": "Rectangle 5374",
    width: 2.091,
    height: 2.091,
    transform: "translate(6.182 9.273)",
    fill: "#15081f"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchGe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-ge.48681e74.svg";
export { ForwardRef as ReactComponent };